import linkedinCampaignObjectiveHtmlUrl from './views/linkedinCampaignObjective.html';

let app = angular.module('app.linkedinCampaignObjective.component', []);

app.component('linkedinCampaignObjective', {
  bindings: {
    selectedObjective: '=',
    selectedGroupType: '=',
    clusterId: '=',
    clientId: '<',
    isEditForm: '=',
    showActions: '=',
    order: '=',
    modelValue: '='
  },
  templateUrl: linkedinCampaignObjectiveHtmlUrl,

  controller: function (OrdersService, FormService, $scope, $timeout) {
    const self = this;

    self.isLoading = false;
    self.hasError = false;
    self.isDisabled = false;

    self.availableObjectives = [];
    self._displayedObjectives = [];
    self._selectedLabel = '';
    self.linkedinPushEnabled = false;

    self.groupTypeObjectiveMapping = {
      'BRAND_AWARENESS': ['Brand Awareness'],
      'WEBSITE_VISIT': ['Website Visit'],
      'ENGAGEMENT': ['Engagement'],
      'VIDEO_VIEW': ['Video View'],
      'LEAD_GENERATION': ['Lead Generation'],
      'WEBSITE_CONVERSION': ['Website Conversion'],
      'JOB_APPLICANT': ['Job Applicant']
    };

    self.humanize = function(str) {
      if (!str || typeof str !== 'string') return '';
      return str.toLowerCase().replace(/_/g, ' ').replace(/\b\w/g, m => m.toUpperCase());
    };

    self.getLabelFromValue = function(val) {
      if (!val && val !== 0) return '';
      if (Array.isArray(val)) return val[1] || val[0] || '';
      if (typeof val === 'object') return val.label || val.name || val.value || '';
      if (typeof val === 'string') return /^[A-Z0-9_]+$/.test(val) ? self.humanize(val) : val;
      return String(val);
    };

    self._containsLabel = function(list, label) {
      if (!Array.isArray(list) || !label) return false;
      const lower = String(label).toLowerCase();
      return list.some(item => String(item || '').toLowerCase() === lower);
    };

    self._buildDisplayedObjectives = function() {
      const base = Array.isArray(self.availableObjectives) ? self.availableObjectives.slice() : [];
      if (self._selectedLabel && !self._containsLabel(base, self._selectedLabel)) {
        base.unshift(self._selectedLabel);
      }
      self._displayedObjectives = base;
    };

    self._syncInternalSelectedLabelFromModel = function() {
      self._selectedLabel = self.getLabelFromValue(self.selectedObjective);
      if (typeof self._selectedLabel === 'string') {
        self._selectedLabel = self._selectedLabel.replace(/^"(.*)"$/, '$1').trim();
      }
    };

    self._onUserSelect = function() {
      self.selectedObjective = self._selectedLabel || '';
    };

    self.extractGroupTypeFromOrder = function(order) {
      if (!order) return null;
      const fields = ['__linkedin_ads_campaign_group_type'];
      for (const f of fields) {
        const v = order[f];
        if (v) return v;
      }
      return null;
    };

    self.updateAvailableObjectives = function() {
      if (!self.selectedGroupType) {
        self.availableObjectives = [];
        self._displayedObjectives = [];
        return;
      }

      let key;
      if (Array.isArray(self.selectedGroupType)) {
        key = String(self.selectedGroupType[1] || '').trim().toUpperCase().replace(/\s+/g, '_');
      } else if (typeof self.selectedGroupType === 'string') {
        key = String(self.selectedGroupType).trim().toUpperCase().replace(/\s+/g, '_');
      } else {
        key = null;
      }

      if (key && self.groupTypeObjectiveMapping[key]) {
        self.availableObjectives = self.groupTypeObjectiveMapping[key].slice();
      } else {
        self.availableObjectives = [];
      }

      self._buildDisplayedObjectives();
    };

    self.updateSelectedGroupType = function () {
      if (!self.selectedGroupType) {
        var source;
        if (self.linkedinPushEnabled) {
          source = self.modelValue;
        } else {
          source = self.order || OrdersService.order;
        }

        if (source) {
          const extractedGroupType = self.extractGroupTypeFromOrder(source);
          if (extractedGroupType) {
            self.selectedGroupType = extractedGroupType;
          }
        }
      }

      self.updateAvailableObjectives();
      self._buildDisplayedObjectives();
    };

    self.getInstanceSettings = function() {
      const params = ["linkedin_ads_campaign_group_push_enable_at_product_form"];
      FormService.getInstanceSettingArray(params)
          .then(function(data) {
            $timeout(function() {
              if (data && data.instance_settings) {
                const flag = data.instance_settings.linkedin_ads_campaign_group_push_enable_at_product_form;
                self.linkedinPushEnabled = (flag === "1");
                self.updateSelectedGroupType();
              }
            });
          })
          .catch(function(err) {
            console.error(err);
            console.log('Settings failed, using fallback with order:', self.order);
            self.updateSelectedGroupType();
          });
    };

    self.$onInit = function() {
      self.order = OrdersService.order || self.order;
      self.isFormEdit = (self.showActions !== false);
      self._syncInternalSelectedLabelFromModel();

      // Debug logging to see what data we have
      console.log('$onInit - order:', self.order);
      console.log('$onInit - modelValue:', self.modelValue);

      self.getInstanceSettings();
      self.loadObjectives();
    };

    self.$onChanges = function(changes) {
      if (changes.selectedObjective) {
        self._syncInternalSelectedLabelFromModel();
        self._buildDisplayedObjectives();
      }

      if (changes.showActions) {
        self.isFormEdit = (self.showActions !== false);
        self._buildDisplayedObjectives();
      }

      // Only reload settings if order or modelValue changed significantly
      if ((changes.order && changes.order.currentValue !== changes.order.previousValue) ||
          (changes.modelValue && changes.modelValue.currentValue !== changes.modelValue.previousValue)) {
        // Re-evaluate group type when data sources change
        self.updateSelectedGroupType();
      }
    };

    self.loadObjectives = function() {
      self.isLoading = true;
      self.hasError = false;
      try {
        self.updateAvailableObjectives();
        self._syncInternalSelectedLabelFromModel();
        self._buildDisplayedObjectives();
        self.isLoading = false;
      } catch (e) {
        self.hasError = true;
        self.isLoading = false;
      }
    };

    self.retryLoad = function() {
      self.loadObjectives();
    };

    self.getObjectiveLabel = function(value) {
      return self.getLabelFromValue(value);
    };

    self.onUserSelect = function() {
      self._onUserSelect();
    };

    self.onObjectiveChange = function() {
      self._onUserSelect();
    };
  }
});